import { barHorizontal } from 'libs/biReportGraphs/index.js';

export function chartBarHorizontalComponent() {
	return {
		bindings: {
			chartWidth: '<',
			chartData: '<',
			links: '<',
			onClick: '&',
			spacing: '<',
		},
		controllerAs: 'vm',
		controller: chartBarHorizontalComponentCtrl,
		template: `<div class="chart-container"></div>`,
	};
}

export class chartBarHorizontalComponentCtrl {
	constructor($element, Theme) {
		'ngInject';
		// save injections but assume bindings are not yet set
		this.$element = $element;
		this.Theme = Theme;
	}

	$onChanges(changes) {
		// initial setup or change
		this.renderChart();
	}

	renderChart() {
		barHorizontal({
			width: this.chartWidth,
			data: this.chartData,
			links: this.links || [],
			onClick: $dataPoint => {
				this.onClick && this.onClick({ $dataPoint });
			},
			linkColor: this.Theme.data().link1,
			withinElement: this.$element[0].firstChild,
			minSpacing: this.spacing || undefined,
			maxSpacing: this.spacing || undefined,
		});
	}
}
